export class CookieHelper
{
    static setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    static getCookie(name, default_value) {
        default_value = default_value ?? null;

        const name_eq = name + "=";
        const ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (' ' === c.charAt(0)) {
                c = c.substring(1, c.length);
            }
            if (0 === c.indexOf(name_eq)) {
                return c.substring(name_eq.length, c.length);
            }
        }

        return default_value;
    }

    static deleteCookie(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}
